import React from 'react';
import { BlockItem } from '../utils/types';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setSelectedTag } from '../redux/app/app-slice';


const BlockInfo = ({ item }) => {
    const dispatch = useAppDispatch();
    const handleTagChange = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(setSelectedTag(event.currentTarget.value));
    };

    return (
        <div className="filter-block-item">
            <div className="stack-sm space-top-md">
                <a className="h6-style" href={item.LinkUrl}>{item.Title}</a>
                {item.Subtitle && <p className="unlink">{item.Subtitle}</p>}
                {item.Description && <p className="unlink">{item.Description}</p>}

                <div className="filter-block-item-tags">
                    <span className="bold unlink">Tags:</span>
                    {item.Tags.map((tag, index) => (
                        <button key={index} type="button" value={tag} className="bold un-button hyperlink" onClick={handleTagChange}  >
                            {tag}
                        </button>
                    ))}
                </div>
            </div>

        </div>
    )
}

export default BlockInfo;